import { DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { ApplicantListAutoReject } from './ApplicantListAutoReject';
import { StyledDialog, StyledDialogContent } from './AutoRejectDialog.styles';

interface AutoRejectDialogProps {
    open: boolean;
    onClose: () => void;
}

export const AutoRejectDialog = ({ open, onClose }: AutoRejectDialogProps) => {
    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
        >
            <DialogTitle>Auto Reject Candidates</DialogTitle>
            <DialogContent>
                <StyledDialogContent>
                    <ApplicantListAutoReject />
                </StyledDialogContent>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Close
                </Button>
            </DialogActions>
        </StyledDialog>
    );
}; 